module.exports = __webpack_public_path__ + "static/media/icon-team-survey-progress-incomplete.f13f6c50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-team-survey-progress-incomplete.svg
// module id = 1854
// module chunks = 0